import brandit_rails from '../../../../api/brandit_rails'
import {
  setAffectedBundlesStatusAction,
  setAffectedBundlesErrorsAction,
  setAffectedBundlesAction
} from './affectedBundles.actions'

/** @typedef {import('redux').Dispatch} */

/**
 * @param {number} productId - The ID of the product to check
 * @returns {(dispatch: Dispatch) => Promise<void>}
 */
export const fetchAffectedBundles = productId => async dispatch => {
  try {
    dispatch(setAffectedBundlesStatusAction('loading'))

    const response = await brandit_rails.get(`/products/${productId}/affected_bundles`)

    if (response.status !== 200) {
      throw new Error('Failed to fetch affected bundles')
    }

    const { count, affected_bundles } = response.data
    dispatch(setAffectedBundlesAction({ count, affectedBundles: affected_bundles }))
    dispatch(setAffectedBundlesStatusAction('succeeded'))

    return response.data
  } catch (err) {
    dispatch(setAffectedBundlesStatusAction('failed'))
    dispatch(setAffectedBundlesErrorsAction({ message: err.message }))
    return undefined
  }
}
